import { format } from 'date-fns';
import styled from 'styled-components';

import DateRangeBadge from 'components/shared/DateRangeBadge';
import DesktopOnly from 'components/shared/responsiveness/DesktopOnly';
import MobileOnly from 'components/shared/responsiveness/MobileOnly';
import { END_DATE, START_DATE } from 'constants/filterKeysConstants';
import { useReferralsInsightsStore } from 'stores/referralsInsightsStore';
import { BodySmallBold } from 'styles/typography';

import {
  BASE_EXPORT_METRICS,
  getReferralExportFilename,
  getReferralExportParams,
  VIEW_BY_DIMENSION_MAP,
} from '../constants';
import ReferralApiExport from '../ReferralApiExport';

export default function ReferralDetailsHeader() {
  const startDate = useReferralsInsightsStore((state) => state.filters[START_DATE]) as Date;
  const endDate = useReferralsInsightsStore((state) => state.filters[END_DATE]) as Date;
  const viewBy = useReferralsInsightsStore((state) => state.viewBy);

  const dimension = VIEW_BY_DIMENSION_MAP[viewBy];

  return (
    <Header>
      <TitleGroup>
        <TitleColumn>
          <Title>Referral Details</Title>
          <MobileOnly>
            <Subtitle>
              {format(startDate, 'MM/dd/yyyy')} - {format(endDate, 'MM/dd/yyyy')}
            </Subtitle>
          </MobileOnly>
        </TitleColumn>
        <DesktopOnly>
          <DateRangeBadge startDate={startDate} endDate={endDate} />
        </DesktopOnly>
      </TitleGroup>
      <RightGroup>
        <ReferralApiExport
          filename={getReferralExportFilename(viewBy)}
          params={getReferralExportParams(dimension, BASE_EXPORT_METRICS)}
        />
      </RightGroup>
    </Header>
  );
}

const Header = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled(BodySmallBold)`
  color: ${({ theme }) => theme.colors.black};
`;

const Subtitle = styled.span`
  color: ${({ theme }) => theme.colors.black50};
  font-size: 10px;
  font-weight: normal;
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
